<template>
  <UiIconControl
    class="ground-station-status-icon"
    :class="[`is-${tone}`, { interactive, 'is-loading': loading, 'has-count': count > 0 }]"
    :title="$t(title)"
    :icon="loading ? 'el-icon-loading' : icon"
    :active="active"
    :toggle="interactive"
    :disabled="loading"
    @click="interactive && !loading && $emit('click')"
  >
    <UiCountBadge :count="count" />
  </UiIconControl>
</template>

<script>
export default {
  name: 'GroundStationStatusIcon',
  props: {
    icon: { type: String, required: true },
    tone: { type: String, default: 'accent' },
    title: { type: String, default: '' },
    count: { type: Number, default: 0 },
    active: { type: Boolean, default: false },
    interactive: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.ground-station-status-icon {
  flex: none;
  --terminal-control-color: var(--ui-color-primary);
  --terminal-control-hover-color: var(--ui-text-inverse);
  --terminal-control-feedback-color: var(--ui-color-primary);
  --terminal-control-feedback-rgb: var(--ui-color-primary-rgb);
  color: var(--ui-color-primary);
  cursor: default;
}

.ground-station-status-icon.interactive {
  cursor: pointer;
}

/* 按钮本身会形成层叠上下文，带角标时需整体高于相邻按钮。 */
.ground-station-status-icon.has-count {
  z-index: 3;
}

.ground-station-status-icon.is-loading {
  cursor: wait;
  opacity: .75;
}

.ground-station-status-icon.is-danger {
  --terminal-control-color: var(--ui-color-danger);
  --terminal-control-hover-color: var(--ui-text-inverse);
  --terminal-control-feedback-color: var(--ui-color-danger);
  --terminal-control-feedback-rgb: var(--ui-color-danger-rgb);
  color: var(--ui-color-danger);
}

.ground-station-status-icon.is-warning {
  --terminal-control-color: var(--ui-color-warning-emphasis);
  --terminal-control-hover-color: var(--ui-text-inverse);
  --terminal-control-feedback-color: var(--ui-color-warning-emphasis);
  --terminal-control-feedback-rgb: var(--ui-color-warning-rgb);
  color: var(--ui-color-warning-emphasis);
}

.ground-station-status-icon.is-neutral {
  --terminal-control-color: var(--ui-text-primary);
  --terminal-control-hover-color: var(--ui-text-inverse);
  color: var(--ui-text-primary);
}

.ground-station-status-icon.is-muted {
  --terminal-control-color: var(--ui-text-disabled);
  --terminal-control-hover-color: var(--ui-text-inverse);
  color: var(--ui-text-disabled);
}

.ground-station-status-icon > .ui-count-badge {
  position: absolute;
  z-index: 3;
  top: -2px;
  right: -2px;
}
</style>
